import { SubscriptionDates } from '../constants/Common';
import type { User } from '../firebase/firebase';
import {
	defaultCloudFunctionServices,
	makeCloudFunctionRequestDeprecated,
} from './BaseCloudFunctionRequests';
import { HTTPSCloudFunctionURLs } from './HTTPSCloudFunctionURLs';

export const fetchSubscriptionTrialDates = async (
	abortSignal: AbortSignal,
	user: User,
): Promise<SubscriptionDates | undefined> => {
	return await makeCloudFunctionRequestDeprecated<SubscriptionDates>({
		abortSignal,
		user,
		url: HTTPSCloudFunctionURLs.StripeGetSubscriptionTrialDates,
		method: 'GET',
		services: defaultCloudFunctionServices,
	});
};
